import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import styled from '@emotion/styled';
import { RootState } from '../../../store/rootReducer';
import { useProductsInfos } from '../../common/hooks/useProductsInfos';
import { breakpoints } from '../../../design-system';
import { RecommendationsBlock } from '../../recommendations/components/RecommendationsBlock';
import { loadRecommendationsHomemade } from '../../recommendations/utils';

const StyledHomeRecommendationsContainer = styled.div`
  margin: 0 16px;

  @media (min-width: ${breakpoints.S}px) {
    margin: 0;
  }
`;

export const HomeRecommendations = () => {
  const [recommendedRefs, setRecommendedRefs] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const { recommendations_home_made_title: title = '', recommendations_home_made_name: name = '' } =
    useSelector((state: RootState) => state.cms.homepage || {});

  const filteredrecommendedRefs = useMemo(
    () => (name && recommendedRefs ? (recommendedRefs[name] ?? []) : []),
    [name, recommendedRefs]
  );

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const data = await loadRecommendationsHomemade({
          type: 'home',
          params: {},
        });
        setRecommendedRefs(data ?? []);
      } catch (e) {
        setRecommendedRefs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, []);

  const { hits } = useProductsInfos(filteredrecommendedRefs);

  if (!filteredrecommendedRefs?.length || loading) {
    return null;
  }

  return (
    <StyledHomeRecommendationsContainer>
      <RecommendationsBlock id="home-page" hits={hits} title={title} />
    </StyledHomeRecommendationsContainer>
  );
};
